import React from "react";
import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";

// Presentational grid of og -> target source autocompletes. Pairing state + defaulting live in
// useSourcePairings; this component just renders and reports changes via onChange(index, option).
const SourcePairingGrid = ({ pairings, sourceOptions, onChange }) => (
  <>
    <h3>Source Pairing Config</h3>
    <Box
      sx={{
        backgroundColor: "#f5f5f5",
        padding: "16px",
        borderRadius: "8px",
        border: "1px solid #ddd",
      }}
      mb={2}
    >
      <Typography variant="body1" sx={{ color: "#333", fontSize: "1rem" }}>
        Each blueprint source is paired to a target source by name. Override any
        pairing below. Columns are matched by name within each paired source.
      </Typography>
    </Box>
    <Grid
      container
      mt={2}
      spacing={2}
      sx={{ backgroundColor: "#f5f5f5", padding: 2, borderRadius: 1 }}
    >
      {pairings.map((p, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Box
            sx={{
              backgroundColor: "#ffffff",
              padding: 2,
              boxShadow: 1,
              borderRadius: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box mb={2} mt={2}>
              <strong>Blueprint Source:</strong> {p?.ogSource?.name}
            </Box>
            <Box>
              <Autocomplete
                options={sourceOptions}
                getOptionLabel={(option) => option?.label || ""}
                value={
                  sourceOptions.find(
                    (option) => option.value === p?.newSource?.sourceId
                  ) || null
                }
                onChange={(event, newValue) => onChange(index, newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Target source for ${p.ogSource.name}`}
                    placeholder="Type to search..."
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>{option.label}</li>
                )}
              />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </>
);

export default SourcePairingGrid;
